var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBasketWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1283 8.35404L14.9368 5.7775C14.9084 5.34 14.5443 5 14.1059 5H3.99843C3.55926 5 3.19593 5.34 3.16676 5.7775L2.50426 15.7225C2.44009 16.6842 3.20259 17.5 4.16676 17.5H7.50009",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55176 6.66797V4.16797C6.55176 2.78714 7.67092 1.66797 9.05176 1.66797V1.66797C10.4326 1.66797 11.5518 2.78714 11.5518 4.16797V6.66797",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6671 12.128V11.5243C14.6671 10.7479 14.0694 10.1133 13.3401 10.1133C12.6107 10.1133 12.0137 10.7479 12.0137 11.5243V12.128",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.417 12.1289H11.2652C10.9194 12.1289 10.6299 12.3922 10.597 12.7367L10.2122 16.7662C10.1739 17.1604 10.4842 17.5016 10.8804 17.5016H15.8018C16.198 17.5016 16.5083 17.1604 16.47 16.7662L16.0852 12.7367C16.0523 12.3922 15.7629 12.1289 15.417 12.1289V12.1289Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasketWhite);
export default __webpack_public_path__ + "static/media/basketWhite.e79e8d5ed74a4b55b108225f884a2ea9.svg";
export { ForwardRef as ReactComponent };